module.exports = __webpack_public_path__ + "static/media/Rashmi Khatri.a352cf93.jpeg";